import { Base, importWhenVisible } from '@studiometa/js-toolkit';
import { Action, Tabs, LargeText, ScrollAnimationParent } from '@studiometa/ui';
import Slider from './Slider/index.js';
import Instagram from './Instagram/index.js';
import ProductLastViewed from './ProductLastViewed.js';
import IngredientReadMore from './IngredientReadMore.js';

/**
 * Sections component
 */
export default class Sections extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Sections',
    components: {
      Action,
      ScrollAnimationParent,
      Tabs,
      LargeText,
      Slider,
      Instagram,
      ProductLastViewed,
      IngredientReadMore,
      TableOfContent: (app) =>
        importWhenVisible(() => import('./TableOfContent.js'), 'TableOfContent', app),
      VideoLinks: (app) => importWhenVisible(() => import('./VideoLinks.js'), 'VideoLinks', app),
      Stories: (app) => importWhenVisible(() => import('./Stories/index.js'), 'Stories', app),
      CollectionLinks: (app) =>
        importWhenVisible(() => import('./CollectionLinks.js'), 'CollectionLinks', app),
      ProductRecommendations: (app) =>
        importWhenVisible(
          () => import('./ProductRecommendations.js'),
          'ProductRecommendations',
          app,
        ),
      Video: (app) => importWhenVisible(() => import('./Video.js'), 'Video', app),
      StoreLocator: (app) =>
        importWhenVisible(() => import('./StoreLocator/index.js'), 'StoreLocator', app),
      Accordion: (app) => importWhenVisible(() => import('./Accordion/index.js'), 'Accordion', app),
    },
  };
}
